import { Plugins } from "@capacitor/core";
import "@capacitor-community/firebase-analytics";

// Constants
import { APP_CONFIG } from '../constants';

// Environments
import { environment } from '../environments/environment';

const { FirebaseAnalytics, Device } = Plugins;

/**
 * Inicia la escucha en Analytics
 */
export const startAnalytics = async () => {

    if (!environment.production) { console.log('startAnalytics'); return; }

    try {
        
        // Sólo para la web se carga la configuración de Firebase
        if ((await Device.getInfo()).platform === 'web') {
            
            FirebaseAnalytics.initializeFirebase(environment.firebaseConfig);
        }

    } catch (error) {

        return false;
    }

    return true;
};

/**
 * Registra en Analytics el evento de la categoría Login Page
 */
export const sendEventLogin = () => {

    if (!environment.production) { console.log('SendEventLogin'); return; }

    try {
        
        FirebaseAnalytics.logEvent({
            name: APP_CONFIG.ANALYTICS.EVENTS.LOGIN.ACTIONS.LOGIN,
            params: {
                'event_category': APP_CONFIG.ANALYTICS.EVENTS.LOGIN.CATEGORY
            }
        });

    } catch (error) {

        return false;
    }

    return true;
};

/**
 * Registra en Analytics el evento de la categoría ResetPassword Page
 */
export const sendEventRecoverPassword = () => {

    if (!environment.production) { console.log('SendEventRecoverPassword'); return; }

    try {

        FirebaseAnalytics.logEvent({
            name: APP_CONFIG.ANALYTICS.EVENTS.RECOVER_PASSWORD.ACTIONS.RECOVER_PASSWORD,
            params: {
                'event_category': APP_CONFIG.ANALYTICS.EVENTS.RECOVER_PASSWORD.CATEGORY
            }
        });

    } catch (error) {

        return false;
    }

    return true;
};

/**
 * Registra en Analytics el evento de la categoría de MENU
 * @param {String} action Key de la acción
 */
export const sendEventMenu = (action) => {

    if (!environment.production) { console.log('SendEventMenu', action); return; }

    try {

        FirebaseAnalytics.logEvent({
            name: APP_CONFIG.ANALYTICS.EVENTS.MENU.ACTIONS[action],
            params: {
                'event_category': APP_CONFIG.ANALYTICS.EVENTS.MENU.CATEGORY
            }
        });

    } catch (error) {

        return false;
    }

    return true;
};

/**
 * Registra en Analytics el evento de la categoría Home Page
 */
 export const sendEventHomePage = () => {

    if (!environment.production) { console.log('SendEventHomePage'); return; }

    try {

        FirebaseAnalytics.logEvent({
            name: APP_CONFIG.ANALYTICS.EVENTS.HOME.ACTIONS.DOWNLOAD,
            params: {
                'event_category': APP_CONFIG.ANALYTICS.EVENTS.HOME.CATEGORY,
                'event_label': APP_CONFIG.ANALYTICS.EVENTS.HOME.LABELS.DOWNLOAD
            }
        });

    } catch (error) {

        return false;
    }

    return true;
};

/**
 * Registra en Analytics el evento de la categoría Qr-Scan Page
 */
export const sendEventQrPage = () => {

    if (!environment.production) { console.log('SendEventQrPage'); return; }

    try {

        FirebaseAnalytics.logEvent({
            name: APP_CONFIG.ANALYTICS.EVENTS.QR_PAGE.ACTIONS.SCAN_QR,
            params: {
                'event_category': APP_CONFIG.ANALYTICS.EVENTS.QR_PAGE.CATEGORY,
                'event_label': APP_CONFIG.ANALYTICS.EVENTS.QR_PAGE.LABELS.SCAN_QR
            }
        });

    } catch (error) {

        return false;
    }

    return true;
};

/**
 * Registra en Analytics el evento de la categoría Document Page
 * @param {String} action Key de la acción
 */
export const sendEventDocumentPage = () => {

    if (!environment.production) { console.log('SendEventDocumentPage'); return; }

    try {

        FirebaseAnalytics.logEvent({
            name: APP_CONFIG.ANALYTICS.EVENTS.DNI_PAGE.ACTIONS.CONTINUE,
            params: {
                'event_category': APP_CONFIG.ANALYTICS.EVENTS.DNI_PAGE.CATEGORY
            }
        });

    } catch (error) {

        return false;
    }

    return true;
};

/**
 * Registra en Analytics el evento de la categoría Contact Page
 */
export const sendEventContactPage = () => {

    if (!environment.production) { console.log('SendEventContactPage'); return; }

    try {
        
        FirebaseAnalytics.logEvent({
            name: APP_CONFIG.ANALYTICS.EVENTS.CONTACT_PAGE.ACTIONS.SEND,
            params: {
                'event_category': APP_CONFIG.ANALYTICS.EVENTS.CONTACT_PAGE.CATEGORY
            }
        });

    } catch (error) {

        return false;
    }

    return true;
};

/**
 * Registra en Analytics el evento de la categoría Detail Page
 * @param {String} action Key de la acción
 */
export const sendEventDetailPage = (action) => {

    if (!environment.production) { console.log('SendEventDetailPage', action); return; }

    try {

        FirebaseAnalytics.logEvent({
            name: action,
            params: {
                'event_category': APP_CONFIG.ANALYTICS.EVENTS.DETAIL_PAGE.CATEGORY
            }
        });

    } catch (error) {

        return false;
    }

    return true;
};

/**
 * Registra en Analytics el evento de la categoría Transaction
 */
export const sendEventTransaction = () => {

    if (!environment.production) { console.log('SendEventTransaction'); return; }

    try {

        FirebaseAnalytics.logEvent({
            name: APP_CONFIG.ANALYTICS.EVENTS.TRANSACTION.ACTIONS.NEW_TRANSACTION,
            params: {
                'event_category': APP_CONFIG.ANALYTICS.EVENTS.TRANSACTION.CATEGORY
            }
        });

    } catch (error) {

        return false;
    }

    return true;
};